import { render, staticRenderFns } from "./UserProfileSetting.vue?vue&type=template&id=a1c70364"
import script from "./UserProfileSetting.vue?vue&type=script&lang=js"
export * from "./UserProfileSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports